import { F } from "./gerencialFields";

export function normalizeTipoText(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/[_/\\|\u2013\u2014-]+/g, " ")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}

const TIPO_RULES = [
  ["BANHEIROS", "Banheiro"],
  ["BANHEIRO", "Banheiro"],
  ["BANHOS", "Banheiro"],
  ["BANHO", "Banheiro"],
  ["WC", "Banheiro"],
  ["CLOSET MASTER", "Closet Master"],
  ["SUITE MASTER", "Suite Master"],
  ["LAVABOS", "Lavabo"],
  ["LAVABO", "Lavabo"],
  ["COZINHAS", "Cozinha"],
  ["COZINHA", "Cozinha"],
  ["ILHAS", "Cozinha"],
  ["ILHA", "Cozinha"],
  ["CLOSETS", "Closet"],
  ["CLOSET", "Closet"],
  ["SAPATEIRA", "Closet"],
  ["SUITES", "Suite"],
  ["SUITE", "Suite"],
  ["DORMITORIOS", "Dormitorio"],
  ["DORMITORIO", "Dormitorio"],
  ["QUARTOS", "Dormitorio"],
  ["QUARTO", "Dormitorio"],
  ["ESCRITORIOS", "Escritorio"],
  ["ESCRITORIO", "Escritorio"],
  ["FINANCEIRO", "Escritorio"],
  ["TRABALHO", "Escritorio"],
  ["GOURMET", "Gourmet"],
  ["CHURRASQUEIRA", "Gourmet"],
  ["SALA DE JANTAR", "Sala de Jantar"],
  ["MESA DE JANTAR", "Sala de Jantar"],
  ["HOME CINEMA", "Home Cinema"],
  ["CINEMA", "Home Cinema"],
  ["LIVING", "Sala de Estar"],
  ["SALAS", "Sala de Estar"],
  ["SALA", "Sala de Estar"],
  ["SOCIAL", "Sala de Estar"],
  ["PAINEL", "Sala de Estar"],
  ["AREA DE SERVICO", "Área de Serviço"],
  ["LAVANDERIAS", "Área de Serviço"],
  ["LAVANDERIA", "Área de Serviço"],
  ["SERVICO", "Área de Serviço"],
  ["VARANDAS", "Varanda"],
  ["VARANDA", "Varanda"],
  ["SACADAS", "Varanda"],
  ["SACADA", "Varanda"],
  ["HALL", "Hall"],
  ["ENTRADA", "Hall"],
  ["GARAGEM", "Garagem"],
  ["ADEGA", "Adega"],
  ["CRISTALEIRAS", "Adega"],
  ["CRISTALEIRA", "Adega"],
  ["BAR", "Bar"],
  ["COPA", "Copa"],
  ["DESPENSA", "Despensa"],
  ["DEPOSITO", "Deposito"],
  ["CONSULTORIO", "Consultorio"],
  ["RECEPCAO", "Recepcao"],
  ["CIRCULACAO", "Circulacao"],
  ["MEZANINO", "Mezanino"],
  ["RODAPE", "Rodape"],
  ["TOTENS", "Totens"],
  ["TOTEM", "Totens"],
  ["BALCAO", "Balcao"],
  ["ARMARIOS", "Armario"],
  ["ARMARIO", "Armario"],
  ["PORTAS", "Portas"],
  ["PORTA", "Portas"],
  ["GUARNICOES", "Guarnicoes"],
  ["GUARNICAO", "Guarnicoes"],
  ["MODULOS", "Modulos"],
  ["MODULO", "Modulos"],
];

function containsKeyword(normalized, keyword) {
  return ` ${normalized} `.includes(` ${keyword} `);
}

export function inferTipoAmbiente(ambiente, fallback = "Outros") {
  const normalized = normalizeTipoText(ambiente);

  if (!normalized) return fallback;

  const [, tipo] = TIPO_RULES.find(([keyword]) =>
    containsKeyword(normalized, keyword),
  ) ?? [];

  return tipo || fallback;
}

export function getTipoAmbienteSeguro(row) {
  const tipoAtual = String(row?.[F.TIPO_AMBIENTE] ?? "").trim();
  const tipoNormalizado = normalizeTipoText(tipoAtual);

  if (!tipoAtual || tipoNormalizado === "OUTROS") {
    return inferTipoAmbiente(row?.[F.AMBIENTE]);
  }

  return tipoAtual;
}
